var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhoneRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPhoneRed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-18.0%",
    width: "136.0%",
    height: "136.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.968627451   0 0 0 0 0.419607843   0 0 0 0 0.274509804  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RedHotPie-Premium+-upgrade",
    transform: "translate(-9.000000, -1224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 1009.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPhoneRed",
    transform: "translate(15.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "phone",
    transform: "translate(12.000000, 13.000000)",
    fill: "#F76B46",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.73313437,0.210191215 C4.40637178,-0.194512889 5.2788609,0.00185819382 5.71373839,0.656005327 L5.71373839,0.656005327 L9.08846968,5.71644224 C9.51280113,6.35882273 9.37282204,7.21939874 8.7668156,7.69421445 L8.7668156,7.69421445 L6.87282578,9.16782759 C6.62294334,9.35877918 6.55185525,9.70460125 6.70618866,9.97860287 L6.70618866,9.97860287 L6.85993618,10.2590005 C7.3665853,11.1868075 7.99861505,12.3442348 10.3288494,14.6752992 C12.6590838,17.0063636 13.8156323,17.6371239 14.7451482,18.143773 L14.7451482,18.143773 L15.0255458,18.2983506 C15.2995962,18.4505846 15.6439536,18.3781294 15.8333916,18.1283446 L15.8333916,18.1283446 L17.3074442,16.2330853 C17.782211,15.6268348 18.6430312,15.487051 19.2852164,15.9118707 L19.2852164,15.9118707 L24.3456533,19.286602 C25.0000934,19.7217236 25.1963668,20.5947498 24.7910768,21.2681336 L24.7910768,21.2681336 L23.5186684,23.3829555 C23.1280256,24.0480393 22.4948729,24.535891 21.7521586,24.7440776 C21.1138305,24.9166713 20.4551916,25.0026996 19.7939649,24.9999355 C16.9208538,24.9999355 12.7407668,23.4899782 7.12578416,17.875435 C0.0671665025,10.8159874 -0.506078869,6.02427906 0.255921004,3.24783997 C0.464351674,2.50527214 0.95215463,1.87221708 1.6170431,1.48133024 L1.6170431,1.48133024 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhoneRed);
export default __webpack_public_path__ + "static/media/icPhoneRed.fe9848a251070e80a33dbbf9bebed881.svg";
export { ForwardRef as ReactComponent };